<div class="ota-content">
  <h1>APS2 Error</h1>
  <p>Message: {{this.message}}</p>
</div>
